var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOrganizeSchema({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 470.11,
    viewBox: "0 0 127.53 124.38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 792h612v-792h-612z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 792h612v-792h-612z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 792h612v-792h-612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.3797e-7 -172.62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.40473 0 0 -.40473 -50.033 468.29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.56 622.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-58.525-47.444-105.97-105.97-105.97s-105.97 47.444-105.97 105.97 47.443 105.97 105.97 105.97 105.97-47.444 105.97-105.97z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436.72 621.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-58.525-47.443-105.97-105.97-105.97-58.524 0-105.97 47.444-105.97 105.97s47.444 105.97 105.97 105.97c58.526 0 105.97-47.444 105.97-105.97z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#231f20"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.40473 0 0 -.40473 -50.033 468.29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.38 531.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-58.525-47.444-105.97-105.97-105.97s-105.97 47.444-105.97 105.97 47.443 105.97 105.97 105.97c26.903 0 47.109-10.675 53.416-14.428 30.894-18.378 52.553-53.698 52.553-91.54z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#231f20"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.40473 0 0 -.40473 -50.033 468.29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.88 619.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c7.095 4.88 27.087 17.264 55.531 17.346 28.372 0.082 48.398-12.122 55.532-16.956-0.423-10.105-2.506-27.566-12.281-46.439-13.267-25.613-33.072-39.097-42.15-44.503-7.325 3.017-29.43 13.215-44.158 38.19-13.264 22.492-12.992 44.159-12.474 52.362",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.88 619.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c7.095 4.88 27.087 17.264 55.531 17.346 28.372 0.082 48.398-12.122 55.532-16.956-0.423-10.105-2.506-27.566-12.281-46.439-13.267-25.613-33.072-39.097-42.15-44.503-7.325 3.017-29.43 13.215-44.158 38.19-13.264 22.492-12.992 44.159-12.474 52.362z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#231f20"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOrganizeSchema);
export default __webpack_public_path__ + "static/media/image_organize_schema.c5353519ba483df5e0761477c9f58afb.svg";
export { ForwardRef as ReactComponent };